var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('div',{staticClass:"pdt graph-container"},[_c('div',[_c('canvas',{ref:"graph",attrs:{"width":"400","height":"200"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }